import React, { FormEvent, useEffect, useLayoutEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import * as _ from 'lodash';
import {
   faCalendarCheck,
   faBarcode,
   faClock,
   faLongArrowAltUp,
   faLongArrowAltDown,
   faArrowUp,
   faArrowDown,
   faAngleDown,
   faFileExcel,
   faFilePdf,
   faCopy,
} from '@fortawesome/free-solid-svg-icons';
import { Container, Table, Card, Fade } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
   Button,
   Datepicker,
   FlexContainer,
   FlexItem,
   Input,
   Select,
   Pagination,
   PageErrorLoad,
   PageListingNotFound,
   ToastList,
} from '@devesharp/react/web';
import * as QueryString from 'querystring';
import { Form } from '@unform/web';
import { FormHelpers } from '@unform/core/typings/types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Style, { ProgressColor } from './ReceivablesDateDetailPage.style';
import { PaymentStatus, Header } from '~/components';
import { formaHour, formatDate, formatPrice } from '~/services';
import { usePaymentsListingPage } from './ReceivablesDateDetailPage.controller';
import { PaymentType } from '~/components/PaymentType';
import history from '~/config/history';
import { TransferType } from '~/components/PaymentType/TransferType';
import { TransferStatus } from '~/components/PaymentStatus/TransferStatus';

export const ReceivablesDateDetailPage: React.FunctionComponent<any> = () => {
   const ctrl = usePaymentsListingPage();

   return (
      <Style>
         <div className="title-page">
            <div className="container">
               <div className="p-3">
                  <div className="row">
                     <div className="col">
                        <h3 className="m-0 mb-1">Pagamentos futuros de {ctrl.date}</h3>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <Container>
            <div className="d-flex pb-3">
               <div className="flex-fill">
                  <div className="text-dark">{/* <b>{ctrl.resource.boletos.length}</b> vendas */}</div>
               </div>
            </div>

            <Card className="p-4">
               {ctrl.errorLoadData && <PageErrorLoad retry={() => ctrl.reloadPage()} nonFullscreen />}

               {!ctrl.resources.length && !ctrl.searching && !ctrl.starting && !ctrl.errorLoadData && (
                  <PageListingNotFound />
               )}

               <div className="d-flex pb-3">
                  <div className="flex-fill">
                     {(ctrl.resources.length || ctrl.searching || ctrl.starting) && !ctrl.errorLoadData && (
                        <div className="pb-3 text-dark">
                           Mostrando <b>1</b>-<b>{ctrl.resourcesTotal < 20 ? ctrl.resourcesTotal : 20}</b> de{' '}
                           <b>{ctrl.resourcesTotal}</b> resultados
                        </div>
                     )}
                  </div>
               </div>

               <div className="text-right pb-2">
                  {ctrl.sum ? (
                     <>
                        Total: <b className="price text-success">{formatPrice((ctrl.sum ?? 0) * 100)}</b>{' '}
                     </>
                  ) : (
                     <>--</>
                  )}
               </div>

               <Table striped bordered hover className="listing">
                  {(ctrl.resources.length || ctrl.searching || ctrl.starting) && !ctrl.errorLoadData && (
                     <thead>
                        <tr>
                           <th />
                           <th>
                              {ctrl.starting || ctrl.searching ? (
                                 <Skeleton height={20} width={100} />
                              ) : (
                                 'ID da transação'
                              )}
                           </th>
                           <th>
                              {ctrl.starting || ctrl.searching ? <Skeleton height={20} width={100} /> : 'Data previsão'}
                           </th>
                           <th>
                              {ctrl.starting || ctrl.searching ? <Skeleton height={20} width={100} /> : 'Data da venda'}
                           </th>

                           <th>{ctrl.starting || ctrl.searching ? <Skeleton height={20} width={100} /> : 'Pagador'}</th>
                           <th>
                              {ctrl.starting || ctrl.searching ? <Skeleton height={20} width={100} /> : 'Tipo de venda'}
                           </th>

                           <th className="text-center">
                              {ctrl.starting || ctrl.searching ? <Skeleton height={20} width={100} /> : 'Status'}
                           </th>

                           <th className="text-right">
                              {ctrl.starting || ctrl.searching ? <Skeleton height={20} width={100} /> : 'Taxa'}
                           </th>

                           <th className="text-right">
                              {ctrl.starting || ctrl.searching ? <Skeleton height={20} width={100} /> : 'Valor bruto'}
                           </th>

                           <th className="text-right">
                              {ctrl.starting || ctrl.searching ? <Skeleton height={20} width={100} /> : 'Valor final'}
                           </th>
                        </tr>
                     </thead>
                  )}
                  <tbody>
                     {!ctrl.starting &&
                        !ctrl.searching &&
                        !ctrl.errorLoadData &&
                        ctrl.resources &&
                        ctrl.resources.map((transaction: any) => (
                           <ItemListing
                              key={transaction.id}
                              transaction={transaction}
                              selected={ctrl.checkSelected(transaction.id)}
                              setSelected={ctrl.onSelect}
                           />
                        ))}

                     {(ctrl.starting || ctrl.searching) &&
                        ctrl.skeletonResources.map((transaction: any) => <ItemListing key={transaction} skeleton />)}
                  </tbody>
               </Table>

               <br />
               <br />
               {!ctrl.errorLoadData && (
                  <Pagination
                     total={ctrl.resourcesTotal}
                     perPage={20}
                     currentPage={ctrl.currentPage}
                     changePage={(page: number) => {
                        ctrl.setCurrentPage(page);
                     }}
                  />
               )}
            </Card>
         </Container>
      </Style>
   );
};

const ItemListing = React.memo(function ItemListing({ transaction, skeleton, selected, setSelected }: any): any {
   const [show, setShow] = useState(false);

   useEffect(() => {
      setShow(true);
   }, []);

   if (skeleton) {
      return (
         <tr>
            <td>
               <Skeleton height={16} width={16} />
            </td>
            <td>
               <Skeleton height={20} width={80} />
            </td>
            <td>
               <Skeleton height={18} width={100} />
               <br />
               <Skeleton height={12} width={50} />
            </td>
            <td>
               <Skeleton height={20} width={80} />
            </td>
            <td>
               <Skeleton height={20} width={80} />
            </td>
            <td>
               <Skeleton height={20} width={80} />
            </td>
            <td>
               <Skeleton height={20} width={80} />
            </td>
            <td>
               <Skeleton height={20} width={80} />
            </td>
            <td>
               <Skeleton height={20} width={80} />
            </td>
         </tr>
      );
   }

   if (transaction?.sum || transaction?.sum === 0) return null;

   function openTransaction(): void {
      history.push(`/payments/detail/${transaction?.payment.id}`);
   }

   return (
      <Fade in={show} timeout={500}>
         <tr className={`cursor-pointer ${selected && 'selected'}`}>
            <td className="text-center">
               <div className="checkbox-btl">
                  <input
                     type="checkbox"
                     value={selected}
                     onChange={(ev) => {
                        setSelected(transaction.id, ev.target.checked);
                     }}
                  />
                  <div className="squad" />
               </div>
            </td>

            <td className="text-nowrap">
               <CopyToClipboard
                  text={transaction.payment.id}
                  onCopy={() =>
                     ToastList.show({
                        message: 'ID copiado com sucesso',
                        type: 'black',
                     })
                  }
               >
                  <span>
                     {transaction.payment.id?.substr(0, 4)}...{transaction.payment.id?.substr(-4)}
                     &nbsp;
                     <FontAwesomeIcon icon={faCopy} />
                  </span>
               </CopyToClipboard>
            </td>
            <td onClick={openTransaction}>
               <div>
                  <b>{formatDate(transaction?.expected_on)}</b>
                  <br />
                  <small className="hour">
                     {/* <FontAwesomeIcon icon={faClock} /> {formaHour(transaction.created_at)} */}
                  </small>
               </div>
            </td>

            <td onClick={openTransaction}>
               <div>
                  <b>{formatDate(transaction.payment.created_at)}</b>
                  <br />
                  {formaHour(transaction.payment.created_at)}
               </div>
            </td>

            <td onClick={openTransaction}>
               {!!transaction.payment.payment_method?.holder_name && transaction.payment.payment_method.holder_name}
               {!transaction.payment.payment_method?.holder_name && <>{transaction.customer?.full_name}</>}
            </td>
            <td onClick={openTransaction}>
               <PaymentType transaction={transaction.payment} />
            </td>
            <td onClick={openTransaction} className="text-center">
               <PaymentStatus transaction={transaction} />
            </td>

            <td onClick={openTransaction} className="text-right text-nowrap">
               <b>{formatPrice((transaction.gross_amount - transaction.amount) * 100)}</b>
            </td>
            <td onClick={openTransaction} className="text-right text-nowrap">
               <b>{formatPrice(transaction.gross_amount * 100)}</b>
            </td>
            <td onClick={openTransaction} className="text-right text-nowrap">
               <b>{formatPrice(transaction.amount * 100)}</b>
               <span className="text-success">
                  <FontAwesomeIcon icon={faArrowUp} />
               </span>
            </td>
            {/* <td onClick={openTransaction} className="text-right"> */}
            {/*   <a href={transaction.} className="btn-icon"> */}
            {/*      PDF{'  '} */}
            {/*      <FontAwesomeIcon icon={faArrowDown} /> */}
            {/*   </a> */}
            {/* </td> */}
         </tr>
      </Fade>
   );
}, _.isEqual);
